@if (isOpen) {
  <div class="modal-overlay" (click)="onClose()">
    <div class="modal-container" (click)="$event.stopPropagation()">
      <!-- Subscription Comparison with Custom Message -->
      <app-subscription-comparison
        [showUpgradeButton]="true"
        [customMessage]="featureMessage"
        (upgrade)="onUpgrade()"
      />
    </div>
  </div>
}
